import type { FunctionComponent } from "react";
// Utilities
import type Category from "../../types/category.types";
import ProductItem from "../product-item/product-item.component";
// Styles
import {
	CategoryContainer,
	CategoryTitle,
	ProductsContainer,
} from "./category-overview.styles";

// Components
// import ProductItem from '../product-item/product-item.component'
interface CategoryOverviewProps {
	category: Category;
}

const CategoryOverview: FunctionComponent<CategoryOverviewProps> = ({
	category,
}) => {
	return (
		<CategoryContainer>
			<CategoryTitle>{category.displayName}</CategoryTitle>

			<ProductsContainer>
				{category.products.slice(0, 4).map((product) => (
					<ProductItem
						key={product.id}
						product={product}
						categoryId={category.id}
					/>
				))}
			</ProductsContainer>
		</CategoryContainer>
	);
};

export default CategoryOverview;
